import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { serviceUnitTypes } from '../ServiceUnitTypes';

export const useServiceUnitTypes = () =>
  useQuery({
    queryKey: [QUERY_KEYS.serviceUnitTypes],
    queryFn: async () => (await serviceUnitTypes.getServiceUnitTypes()).data,
  });
